<template>
  <div>
    <!-- 登录标题 -->
    <div class="loginTitle">
      <div class="w">
        <div class="loginTitle-logo fl">
          <img src="https://www.myfund.com/images/zhx_logo.png" alt="" class="logo">
        </div>
        <div class="loginTitle-phone fr">
          <p>咨询热线：<span>400-818-8000</span> </p>
        </div>
      </div>
    </div>
    <!-- 登录内容 -->
    <div class="loginCon">
      <div class="w" style="position: relative; height: 100%;">
        <div class="loginCon_box">
          <div class="loginCon_con">
            <div class="tit">
              <span>登录</span>
            </div>
            <div class="login_Form">
              <el-form :model="loginForm" ref="loginFormRef" class="demo-ruleForm">
                <el-form-item prop="id">
                  <el-input @keyup.enter.native="LoginEnter" ref="loginRef" @blur="LoginVerification" placeholder="手机号码/身份证" prefix-icon="el-icon-user-solid" v-model="loginForm.id">
                  </el-input>
                  <el-input style="position:fixed;bottom:-9999px;"></el-input>
                  <div class="phoneError" v-show="phoneErrorMsgShow">{{phoneErrorMsg}}</div>
                </el-form-item>
                <el-form-item prop="passwd">
                  <el-input type="password" style="width:0;height:0;"></el-input>
                  <el-input @keyup.enter.native="PwdEnter" ref="psdRef" @blur="PwdVerification" type="password" onfocus="this.type='password'" autocomplete="off" placeholder="请输入登录密码" prefix-icon="el-icon-s-goods" v-model="loginForm.passwd" show-password>
                  </el-input>
                  <el-input style="position:fixed;bottom:-9999px;"></el-input>
                  <div class="passError" v-show="passErrorMsgShow">{{passErrorMsg}}</div>
                </el-form-item>
                <div class="errorMsg" v-show="errorMsgShow">
                  <img src="../../assets/images/loginfal.png" alt="">
                  <span class="msg">{{errorMsg}}</span>
                </div>
                <el-form-item style="margin-bottom: 16px;">
                  <el-button type="login" style="margin-top: 10px;" @click="login">{{loginTit}}</el-button>
                </el-form-item>
                <el-form-item style="margin-bottom: 13px;">
                  <el-button type="login" @click="registerClick" plain style="background: transparent;color: #0b7ac1;border-color: #0b7ac1;">注册</el-button>
                </el-form-item>
              </el-form>
            </div>
            <!-- <el-checkbox v-model="rememberPsw">记住密码</el-checkbox> -->
            <div class="forget" @click="forgetPass">忘记密码?</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 登录介绍 -->
    <div class="loginIntroduce" style="margin-bottom: 37px;">
      <!-- style="border-bottom: 1px solid #d5d5d5;" -->
      <div class="w" style="border-bottom: 1px solid #d5d5d5;">
        <ul>
          <li>
            <img src="../../assets/images/20200911_zy.png" alt="">
            <span>深耕基金领域十六年</span>
          </li>
          <li>
            <img src="../../assets/images/20200911_zg.png" alt="">
            <span>证监会批准独立基金销售机构</span>
          </li>
          <li>
            <img src="../../assets/images/20200911_aq.png" alt="">
            <span>民生银行全程资金监管</span>
          </li>
        </ul>
      </div>
    </div>
    <lvFooter></lvFooter>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
import lvFooter from '../../components/lv-footer/lv-footer.vue';
export default {
  name: "index",
  components: {
    lvFooter
  },
  data () {
    return {
      loginTit: '登录',
      rememberPsw: true,
      loginForm: {
        id: '',
        passwd: ''
      },
      // 错误信息
      errorMsg: '',
      errorMsgShow: false,
      // 手机和密码错误信息
      phoneErrorMsg: '',
      phoneErrorMsgShow: false,
      passErrorMsg: '',
      passErrorMsgShow: false,
      registerFlag: false,//判断手机号是否注只注册未开户
      sfzFlag: false, //判断身份证输入时是否通过
      sjhFlag: false, //判断手机号输入时是否通过
      pass: false,
    }
  },
  created () {
    document.title = '展恒基金-个人中心'
  },
  methods: {
    // 用户名验证
    LoginVerification () {
      const id = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
      const cell = /^(13|15|16|17|18|14|19)\d{9}$/g;
      if (id.test(this.loginForm.id) || cell.test(this.loginForm.id)) {
        this.phoneErrorMsgShow = false
      } else {
        this.phoneErrorMsgShow = true
        this.phoneErrorMsg = '请输入正确的手机号或身份证号'
      }
    },
    // 用户名enter
    LoginEnter () {
      this.LoginVerification();
      if (!this.phoneErrorMsgShow) {
        this.$refs.psdRef.focus()
      }
    },
    //密码验证 
    PwdVerification () {
      const reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      this.pass = false;
      if (this.loginForm.passwd.trim() === '') {
        this.passErrorMsgShow = true
        this.passErrorMsg = '密码不能为空！'
      }
      else if (reg.test(this.loginForm.passwd)) {
        this.passErrorMsgShow = true
        this.passErrorMsg = '密码不能为汉字'
      } else if (this.loginForm.passwd.length <= 5 || this.loginForm.passwd.length >= 20) {
        this.passErrorMsgShow = true
        this.passErrorMsg = '密码长度在5-20之间'
      } else {
        this.passErrorMsgShow = false
        this.pass = true;
      }
    },
    //密码enter
    PwdEnter () {
      this.PwdVerification();
      if (this.passErrorMsgShow) {
        return
      } else if (this.phoneErrorMsgShow || this.loginForm.id.trim() === '') {
        this.$refs.loginRef.focus()
      } else {
        this.login();
      }
    },
    async login () {
      this.LoginVerification()
      this.PwdVerification()
      this.errorMsgShow = false
      var cell = /^(13|15|16|17|18|14|19)\d{9}$/g.test(this.loginForm.id);
      if (this.loginForm.id.length == 11 && cell) {
        // console.log("判断账号是手机号")
        await this.judgeNumber()
        if (this.registerFlag == true) {     //判断手机号是否注只注册未开户
          await this.numberNumer()
          return
        }
      } else if (this.loginForm.id.length == 18) {
        // console.log("判断账号是身份证")
        await this.judgeId()
      }
      if (this.pass && (this.sfzFlag || this.sjhFlag)) {
        // console.log("手机号或身份证及密码初步校验通过")
        this.loginClick();
      }
    },

    // 判断手机号是否被绑定过
    async judgeNumber () {
      await this.$http.post(this.$apiPath.judge, {
        Phonenumber: this.loginForm.id
      }).then(res => {
        // console.log(res);
        if (res.data.data.returnstatus == "该手机号已开户") {
          this.registerFlag = false;
          this.sjhFlag = true;
        } else if (res.data.data.returnstatus == "该手机号已注册未开户") {
          this.registerFlag = true;
          this.sjhFlag = true;
          return
        } else if (res.data.data.returnstatus == "该手机号未注册及开户") {
          this.sjhFlag = false;
          this.errorMsgShow = true;
          this.errorMsg = '该手机号未注册,请输入正确的手机号！'
          this.loginTit = '登录'
          return;
        } else {
          this.errorMsgShow = true;
          this.errorMsg = res.data.data.returnstatus
          this.loginTit = '登录'
        }
      }).catch(err => {
        console.log("接口异常！")
      })
    },
    // 只注册手机号的用户登录               // 只注册登录1
    async numberNumer () {
      let DESKEY = {
        key1: 'pAssWorD',
        key2: 'Kfit',
        key3: 'DeS'
      }
      let passWord = this.$des.enString(this.loginForm.passwd, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3)
      this.loginTit = '正在登录...'
      await this.$http.post(this.$apiPath.loginNumber, {
        Phonenumber: this.loginForm.id,
        Password: passWord,
        type: '2'
      }).then(res => {
        if (res.data.success) {
          if (res.data.data.returnstatus == "登陆成功" && res.data.data.code == "0000") {
            this.setCookie("register-phone", this.loginForm.id, 7);
            this.setCookie("register-ps", passWord, 7);
            this.$commonJs.setDomainCookie('u_name', this.loginForm.id)
            this.$commonJs.setDomainCookie('u_phone', this.loginForm.id)
            this.$router.push('/indexno')
          } else {
            this.loginTit = '登录'
            this.errorMsgShow = true;
            this.errorMsg = '用户不存在或密码输入错误！'
          }
        } else {
          console.log("接口返回异常！")
        }

      }).catch(err => {
        console.log("接口异常！")
      })
    },
    //判断身份证是否已经被绑定过
    async judgeId () {
      const oldId = this.loginForm.id.trim()
      const newId = oldId.substr(17, 1)
      if (newId == 'x') {
        oldId = oldId.replace('x', 'X');
      }
      await this.$http.post(this.$apiPath.getOpenAccountStatus, {
        depositacct: '',
        certificatetype: '0',
        certificateno: oldId
      }).then(res => {
        const total = res.data
        // console.log(res.data);
        if (total.code == '200' && total.message == '成功') {
          if (total.data[0].openstat == "already") { //银行卡已经绑定
            this.sfzFlag = true; //身份证号直接输入密码，手机号继续判断
          } else if (total.data[0].openstat == "freeze") { //银行卡被冻结
            this.sfzFlag = true; //身份证号直接输入密码，手机号继续判断
          } else {
            this.errorMsgShow = true;
            this.errorMsg = '初次登录,请输入手机号'
            return;
          }
        }
      }).catch(err => { })
    },

    // 登录
    loginClick () {
      this.loginTit = '正在登录...'
      this.$http.post(this.$apiPath.userLogin, {
        id: this.loginForm.id,
        passwd: this.$des.enString(this.loginForm.passwd, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
      }).then(res => {
        // console.log(res);
        if (res.data.message == '缺失必填参数') {
          this.loginTit = '登录'
          this.errorMsgShow = true;
          this.errorMsg = '请填入完整信息'
          return
        }
        if(res.data.code == 200 && res.data.data.loginflag) {
          this.loginTit = '正在登录...'
          let mainData = res.data.data
          let passWord = this.$des.enString(this.loginForm.passwd, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3)
          if(res.data.data.custInfo) {
            //身份证
            let certificateno = Base64.encode(mainData.custInfo.certificateno);
            let custname = Base64.encode(mainData.custInfo.custname);
            this.setUserInfo(passWord, certificateno, mainData.custInfo.mobileno, mainData.sessionid, mainData.custInfo.custno, custname, mainData.risklevelInfo[0].risklevel)    // 存cookie
            this.$commonJs.setDomainCookie('u_name', mainData.custInfo.custname)
            this.$commonJs.setDomainCookie('u_risk', mainData.risklevelInfo[0].risklevel)
            this.$commonJs.setDomainCookie('u_custno', mainData.custInfo.custno)
            this.$commonJs.setDomainCookie('u_phone', mainData.custInfo.mobileno)
            // 重要信息
            // window.sessionStorage.setItem('token', mainData.sessionid) // token
            // 配置外部跳转链接
            let queryCode = window.sessionStorage.getItem('querycode')
            let queryAmount = window.sessionStorage.getItem('amount')
            let queryType = window.sessionStorage.getItem('business')
            let riskStr = window.sessionStorage.getItem('riskStr')
            let leval = window.sessionStorage.getItem('leval')
            let question = window.sessionStorage.getItem('question')
            if (queryCode) {
              this.$router.push({
                name: this.$commonJs.getSession(queryType),
                params: {
                  fundcode: queryCode,
                  amount: queryAmount,
                  riskStr: riskStr,
                  leval: leval,
                  question: question
                }
              })
            } else {
              this.$router.push('/myAssets')
            }
          } else {
            this.loginTit = '登录'
            this.errorMsgShow = true;
            this.errorMsg = '账号或密码错误,请重新输入'
          }
        } else {
          this.loginTit = '登录'
          this.errorMsgShow = true;
          this.errorMsg = res.data.message
        }
      }).catch(err => {
        this.loginTit = '登录'
        this.errorMsgShow = true;
        this.errorMsg = '请求超时，请联系客服400-818-8000'
      })
    },
    // 储存表单信息
    setUserInfo: function (passWord, certificateno, mobileno, sessionid, custno, custname, risk) {
      // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
      // 如果没有勾选，储存的信息为空
      if (this.rememberPsw) {
        this.setCookie("u_phone1", mobileno, 7);
        this.setCookie("Password", passWord, 7);
        this.setCookie("sessionid", sessionid, 3);
        this.setCookie("u_id", certificateno, 3);
        this.setCookie("u_custno1", custno, 3);
        this.setCookie("u_name1", custname, 3);
        this.setCookie("acticePath", "/myAssets", 3);
        this.setCookie("u_risk", risk, 3);
      } else {
        this.setCookie("Login", "");
        this.setCookie("Password", "");
      }
    },
    // 获取cookie
    getCookie: function (key) {
      if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(key + "=");
        if (start !== -1) {
          start = start + key.length + 1;
          var end = document.cookie.indexOf(";", start);
          if (end === -1) end = document.cookie.length;
          return unescape(document.cookie.substring(start, end));
        }
      }
      return "";
    },
    // 保存cookie
    setCookie: function (cName, value, expiredays) {
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + expiredays);
      document.cookie =
        cName +
        "=" +
        decodeURIComponent(value) +
        (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
    },
    // 注册
    registerClick () {
      this.$router.push('/register')
    },
    // 忘记密码
    forgetPass () {
      if (this.isPoneAvailable(this.loginForm.id)) {
        this.$http.post(this.$apiPath.judge, {
          Phonenumber: this.loginForm.id
        }).then(res => {
          // console.log(res);
          if (res.data.data.returnstatus == "该手机号已开户") {
            this.$router.push({ name: 'forgetPass' })
          } else if (res.data.data.returnstatus == "该手机号已注册未开户") {
            this.$router.push({ name: 'forgetPassTwo', params: { number: this.loginForm.id } })
          } else if (res.data.data.returnstatus == "该手机号未注册及开户") {
            this.$message.error('该手机号未注册，请先点击“注册”按钮进行注册')
          } else {
            this.$message.error(res.data.data.returnstatus)
          }
        }).catch(err => {
          console.log("接口异常！")
        })
      } else {
        this.$message.error('请先输入手机号，再次点击“忘记密码”！')
      }
    },
    // 手机号验证
    isPoneAvailable (str) {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(str)) {
        return false;
      } else {
        return true;
      }
    }
  }
}
</script>
<style lang="less" scoped>
.loginCon {
  position: relative;
  width: 100%;
  min-width: 1200px;
  height: 450px;
  background: url(../../assets/images/20210302_loginBg.png) no-repeat;
  background-size: auto 100%;
  background-position: center;
  .loginCon_box {
    width: 350px;
    height: 370px;
    box-sizing: border-box;
    background: #fff;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    right: 20px;
    border-radius: 5px;
    padding: 22px;
    .loginCon_con {
      width: 306px;
      height: auto;
      position: relative;
      margin: 0;
      .tit {
        width: 100%;

        font-weight: 500;
        color: #000000;
        height: auto;
        margin-top: 5px;
        margin-bottom: 21px;
        text-align: center;
        span {
          font-size: 24px;
        }
      }
      .forget {
        // position: absolute;
        // bottom: -32px;
        width: 100%;
        height: 20px;
        line-height: 20px;
        text-align: right;
        font-size: 12px;
        font-weight: 500;
        color: #0d7ac2;
        cursor: pointer;
      }
    }
  }
}
.loginIntroduce {
  width: 100%;
  height: 132px;
  // margin-bottom: 70px;
  li {
    width: 33.33%;
    height: 100%;
    line-height: 132px;
    float: left;
    // position: relative;
    box-sizing: border-box;
    // padding-left: 60px;
    font-size: 0;
    text-align: center;
    img {
      width: 81px;
      height: 41px;
      position: relative;
      top: -6px;
      margin-right: 23px;
    }
    span {
      font-size: 18px;
      font-weight: 400;
      color: #797979;
    }
  }
}
// 错误信息
.errorMsg {
  position: absolute;
  height: 26px;
  line-height: 26px;
  left: 0;
  right: 0;
  top: 158px;
  font-size: 12px;
  font-weight: 400;
  color: #ff6066;
  text-align: center;
  img {
    vertical-align: top;
    margin-top: 4px;
  }
  .msg {
    height: 26px;
    line-height: 26px;
    margin-left: 10px;
  }
}
.phoneError,
.passError {
  position: absolute;
  left: 0;
  top: 31px;
  color: #ed0000;
  font-size: 12px;
}
</style>